import React, { useEffect } from 'react';
import CustomBox from '../CommonComp/CustomBox/CustomBox';
import { Box, Grid } from '@mui/material';
import { commonItemsSelector } from '../../redux/common';
import { useSelector } from 'react-redux';
import ImageUploadBackground from './ImageUploadBackground';


function BannersBackground({ parentKey}) {  
  const {loading, appSetting} = useSelector(commonItemsSelector)
 const data=appSetting?.items?.features?.background_images?.[0] || [];
  return (
    <>
      <CustomBox padding={3} sx={{minHeight: 200}}>
          <Grid container spacing={2}>
            
                <Grid  xs={12} >
                    <ImageUploadBackground item={data} parentKey={'background_Images'} />
                </Grid>
          </Grid>
      </CustomBox>
    </>
  );
}

export default BannersBackground;
